import * as React from "react";

import { User, UserUpdate } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { getAnnualIncomeError } from "@/validations/annualIncome";

/** 設定内の保存だけで使用。成功したレスポンスを受け取るまで表示済みプロフィールを更新しない。 */
export const useSettingsUserUpdate = (onSavedUser?: (user: User) => void) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const inFlight = React.useRef(false);
  const mounted = React.useRef(true);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const update = async (request: UserUpdate): Promise<User | undefined> => {
    if (inFlight.current) return;
    inFlight.current = true;
    setLoading(true);
    setError("");
    try {
      const response = await PropallyApiFactory().v1UserPatch(request, { withCredentials: true });
      // 保存中に別の内容へ移っても、成功したUserを保存済み値へ反映する。
      onSavedUser?.(response.data);
      return mounted.current ? response.data : undefined;
    } catch (exception) {
      const response = exception.response;
      const messages = {
        INVALID_PHONE_NUMBER_AUTH_CODE: "電話番号認証コードが不正です",
        EMAIL_ALREADY_TAKEN: "このメールアドレスは既に使用されています",
        EXTERNAL_AUTH_CANNOT_CHANGE_EMAIL: "このメールアドレスは外部サービスで登録されています",
      };
      const message =
        getAnnualIncomeError(exception) ||
        messages[response?.data?.code] ||
        ([400, 401].includes(response?.status)
          ? "更新に失敗しました。画面をリロードし、再度ログインしてください"
          : "更新に失敗しました。時間をおいて、もう一度お試しください");
      if (mounted.current) setError(message);
    } finally {
      inFlight.current = false;
      if (mounted.current) setLoading(false);
    }
  };
  return { update, loading, error };
};
